import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import { DateTime } from 'luxon';

const MOSCOW_ZONE = 'Europe/Moscow';

export type RawDateTime = DateTime | number | string | null | undefined;

const mskMoment = (value: RawDateTime): DateTime | null => {
    if (!value) {
        return null;
    }
    if (DateTime.isDateTime(value)) {
        return value;
    }
    if (isNumber(value)) {
        return DateTime.fromMillis(value, { zone: MOSCOW_ZONE });
    }
    if (isString(value)) {
        if (value === 'now') {
            return DateTime.local().setZone(MOSCOW_ZONE);
        }
        return DateTime.fromISO(value, { zone: MOSCOW_ZONE });
    }
    throw new Error(`Неверный формат даты {${typeof value}} "${value}"`);
};

export default mskMoment;
